<template>
  <ValidationProvider
    v-slot="{ errors }"
    :bails="provider.Bails"
    :class="provider.Class"
    :immediate="provider.Immediate"
    :name="catalog[field].Label"
    :rules="validationRules"
    :tag="provider.Tag"
    :vid="vid"
  >
    {{ updateErrors(errors) }}
    <b-field :type="{ 'is-danger': errors[0] }">
      <template v-if="!errorOff" #message>
        <kst-list hide-empty :items="getErrors(errors)"/>
      </template>

      <slot name="left"/>
      <b-datepicker expanded trap-focus
        icon="calendar-today"
        ref="myField"
        v-model="data[field]"
        :date-formatter="dateFormatter"
        :disabled="theDisabled"
        :id="vid"
        :month-names="AppCatalog.MonthLongNames"
        :position="position"
        :range="isRange"
        :mobile-native="false"
        @input="handleInput"
      />
      <template v-if="isRange">
        <div class="control">
          <kst-dropdown
            :options="dateRangeOptions"
            @change="handleDateRange_change"
          />
        </div>
      </template>
      <template v-if="!catalog[field].Required">
        <template v-if="!theDisabled">
          <div class="control">
            <kst-tooltip clear-mode hover-only :content="catalog[field].Label">
              <kst-button clear-mode @click="handleClear"/>
            </kst-tooltip>
          </div>
        </template>
      </template>
      <slot name="right" />
    </b-field>
  </ValidationProvider>
</template>

<script>
import AppCatalog from "../../../services/App/AppCatalog.js";
import Model from "./Input_Date_Model.js";

export default {
  props: {
    field: {
      type: String,
      required: true 
    },
    data: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    },
    disabled: Boolean,
    errorOff: Boolean,
    loadOnFocus: Boolean,
    position: String,
    vid: String,
    validationRules: {
      type: Object
    },
    // catalog
    provider: Object
  },
  data: () => ({
    AppCatalog: AppCatalog
  }),
  computed: {
    dateFormatter() {
      if (this.isRange) {
        return this.$kst.Format.getRangeShortDate;
      }
      return this.$kst.Format.getShortDate;
    },
    dateRangeOptions() {
      return Model.createDateRangeOptions();
    },
    isRange() {
      return this.catalog[this.field].IsRange === true ? true : false;
    },
    theDisabled() {
      if (this.disabled === undefined) {
        return this.catalog[this.field].ReadOnly;
      }
      return this.disabled;
    }
  },
  mounted() {
    if (this.loadOnFocus) {
      this.focus();
    }
  },
  methods: {
    focus() {
      this.$refs.myField.focus();
    },

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },
    handleClear() {
      this.data[this.field] = null;
      this.$emit(this.$kst.Enum.Event.Input);
    },
    updateErrors(errors) {
      this.$emit(this.$kst.Enum.Event.Error, errors);
    },

    getErrors(errors) {
      let result = [];

      for (const error of errors) {
        if (error !== this.$kst.Vee.ValidRule) {
          result.push(error);
        }
      }

      return result;
    },

    /*** select ***/

    handleDateRange_change(value) {
      this.data[this.field] = [
        value[Model.OptionKey.StartDate],
        value[Model.OptionKey.EndDate]
      ]
      this.handleInput();
    }
  }
}
</script>